import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setIsRemovingEmailAddress', function setIsRemovingEmailAddress(
    newValue: boolean
) {
    store.userInfo.isRemovingEmailAddress = newValue;
});
